import { ICasinoProvidersConfiguration } from './types/configuration';
import { ConvertorsTypes } from './types/convertors';

// Slots
import { config as outcome } from './providersData/Outcome';
import { config as popokgaming } from './providersData/Popokgaming';
import { config as platipus } from './providersData/Platipus';
import { config as hacksaw } from './providersData/Hacksaw';
import { config as betOnGames } from './providersData/BetOnGames';
import { config as winfinity } from './providersData/WInfinity';
import { config as belatra } from './providersData/Belatra';
import { config as slotegrator } from './providersData/Slotegrator';
import { config as pragmatic } from './providersData/Pragmatic';
import { config as rubyplay } from './providersData/Rubiplay';
import { config as redrake } from './providersData/RedRake';
import { config as pragmaticRGS } from './providersData/PragmaticRGS';

import { config as upgaming } from './providersData/Upgaming';
import { config as amusnet } from './providersData/Amusnet';
import { config as amigogaming } from './providersData/AmigoGaming';
import { config as hp100 } from './providersData/100Hp';
import { config as bluejack } from './providersData/Bluejack';
import { config as bgaming } from './providersData/Bgaming';
import { config as evoPlay } from './providersData/EvoPlay';
import { config as galaxsys } from './providersData/Galaxsys';
import { config as goldenRace } from './providersData/GoldenRace';
import { config as mascot } from './providersData/Mascot';
import { config as pgsoft } from './providersData/Pgsoft';
import { config as smartsoft } from './providersData/SmartSoft';
import { config as universalRace } from './providersData/Universalrace';

// Live{
import { config as evolution } from './providersData/Evolution';
import { config as vivogaming } from './providersData/Vivogaming';
import { config as pragmaticLive } from './providersData/PragmaticLive';
import { config as ezugi } from './providersData/Ezugi';
import { config as tvBet } from './providersData/TVBet';
import { config as xpg } from './providersData/XPG';
import { config as popokgamingLive } from './providersData/PopokgamingLive';
import { config as jacktop } from './providersData/Jacktop';
import { config as amusnetLive } from './providersData/AmusnetLive';
import { config as winfinityLive } from './providersData/WInfinityLive';

export const slotProvidersConfiguration: ICasinoProvidersConfiguration<ConvertorsTypes> = {
  'pragmatic-rgs': pragmaticRGS,
  '100hp': hp100,
  outcome,
  popokgaming,
  platipus,
  hacksaw,
  betOnGames,
  winfinity,
  belatra,
  slotegrator,
  pragmatic,
  rubyplay,
  redrake,
  upgaming,
  amusnet,
  amigogaming,
  bluejack,
  bgaming,
  evoPlay,
  galaxsys,
  goldenRace,
  mascot,
  pgsoft,
  smartsoft,
  universalRace,
  // Live
  evolution,
  vivogaming,
  pragmaticLive,
  ezugi,
  tvBet,
  xpg,
  popokgamingLive,
  jacktop,
  amusnetLive,
  winfinityLive,
};

export default slotProvidersConfiguration;
